import { Col, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Header, StoryPanel
} from 'screens/Admin/components';
import { Filters, List } from './components';

const Stories = ({}) => {
  const [owner, setOwner] = useState(null),
    [dataId, setDataId] = useState(null),
    [loading, setLoading] = useState(null),
    stories = useSelector((state) => state.admin.stories),
    fetching = useRef(false),
    skip = useRef(0),
    dispatch = useDispatch(),
    scrollId = 'admin-stories-list';

  useInfiniteScroll(scrollId, getStories);

  useEffect(() => {
    skip.current = stories?.length || 0;
  }, [stories]);

  useEffect(() => {
    skip.current = 0;
    setLoading(true);

    getStories(true);
  }, [owner]);

  function handleSelect(postId) {
    setDataId(postId);
  }

  async function getStories(newSearch) {
    if (fetching.current) return;
    fetching.current = true;

    const res = await Api.post('/admin/getStories', {
      skip: skip.current || 0,
      ownerId: owner?._id
    });
    if (!res) return (fetching.current = false);

    dispatch({
      type: newSearch ? 'ADMIN_SET_STORIES' : 'ADMIN_ADD_STORIES',
      payload: res
    });

    fetching.current = false;
    setLoading(false);
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Stories</Text>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters owner={owner} setOwner={setOwner} className="filters" />

        <List data={stories} dataId={dataId} onClick={handleSelect} loading={loading} />
      </Col>

      <StoryPanel dataId={dataId} setDataId={handleSelect} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Stories;
